import * as types from "../../constants/actionTypes";

export const setLoader = (data) => {
    return {
        type: types.MODULE_REKAMMEDIS_SET_LOADER,
        value: data
    }
};

export const getListRekamMedis = () => {
    return {
        type: types.MODULE_REKAMMEDIS_LISTDATA_REKAMMEDIS_GET,
    }
};

export const getDetailRekamMedis = (value) => {
    return {
        type: types.MODULE_REKAMMEDIS_DETAIL_REKAMMEDIS_GET,
        value
    }
};


